import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';
import ROUTES from 'Utilities/routes';

const { VEHICLE_DETAILS } = ANALYTICS_CATEGORIES;

export const triggerSHFeedbackModalSubmittedEvent = (enquiryId: number): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_DETAILS,
		customData: {
			button_label: 'Submit feedback',
			url: ROUTES.VEHICLE.as(enquiryId),
		},
		name: 'dlr_service_history_feedback_modal_submit_clicked',
		schemaName: SNOWPLOW_EVENTS.CTA_CLICKED.SCHEMA,
		version: SNOWPLOW_EVENTS.CTA_CLICKED.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
